import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

const STORAGE_KEY = "sh_cart_v1";

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (raw) return JSON.parse(raw);
        } catch {}
        return [];
    });
    const [open, setOpen] = useState(false);
    const [pendingCoupon, setPendingCoupon] = useState(
        () => localStorage.getItem("sh_pending_coupon") || ""
    );

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }, [items]);

    useEffect(() => {
        if (pendingCoupon) localStorage.setItem("sh_pending_coupon", pendingCoupon);
        else localStorage.removeItem("sh_pending_coupon");
    }, [pendingCoupon]);

    const add = (item, options = {}) => {
        setItems((prev) => {
            const ex = prev.find((i) => i.id === item.id);
            if (ex) return prev.map((i) => (i.id === item.id ? { ...i, qty: i.qty + 1 } : i));
            return [...prev, { id: item.id, name: item.name, price: item.price, image_url: item.image_url, category: item.category, qty: 1 }];
        });
        if (!options.silent) setOpen(true);
    };

    const addBundle = (bundleItems, couponCode) => {
        setItems((prev) => {
            const map = new Map(prev.map((i) => [i.id, { ...i }]));
            for (const b of bundleItems) {
                const ex = map.get(b.item_id);
                if (ex) ex.qty += b.quantity;
                else map.set(b.item_id, { id: b.item_id, name: b.name, price: b.price, image_url: b.image_url, qty: b.quantity });
            }
            return Array.from(map.values());
        });
        if (couponCode) setPendingCoupon(couponCode);
        setOpen(true);
    };

    const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));

    const setQty = (id, qty) => {
        if (qty <= 0) return remove(id);
        setItems((prev) => prev.map((i) => (i.id === id ? { ...i, qty } : i)));
    };

    const clear = () => { setItems([]); setPendingCoupon(""); };

    const consumePendingCoupon = () => {
        const c = pendingCoupon;
        setPendingCoupon("");
        return c;
    };

    const setPendingCouponDirect = (code) => setPendingCoupon(code);

    const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
    const count = items.reduce((s, i) => s + i.qty, 0);

    return (
        <CartContext.Provider value={{ items, add, addBundle, remove, setQty, clear, subtotal, count, open, setOpen, pendingCoupon, consumePendingCoupon, setPendingCouponDirect }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
